import './js/firebase-main.js';
// import './js/firebase-api.js';
import './js/mobile-menu.js';
import './js/dark.js';
import './js/support.js';
// import './js/footer.js';
// import './js/category.js';
// import './js/modal-window.js';
// import './js/book.js';
// import './js/add-and-remove-book.js'
import './js/shopping-list.js'
import './js/modal-auth.js';
// import './js/see-more-btn.js';
import './js/header.js';
import './js/loader.js';
import './js/scroll-up-btn.js';